<template>
    <b-card class="shadow">
        <form @submit.prevent="$emit('add')" ref="addItem">
            <div class="row">
                <div class="col-md-12">
                    <h4>Dados de Acesso ao Sistema</h4>
                </div>
                <form-input
                    v-model="item.email"
                    :required="true"
                    label="E-mail"
                />
                <div class="col-md-12">
                    <b-form-group class="mb-2" label-for="password">
                        <template v-slot:label class="d-block font-weight-bold"
                            >{{ $t("Senha") }}
                            <span class="text-danger">*</span></template
                        >
                        <b-input-group>
                            <b-form-input
                                :type="passwordInput"
                                id="password"
                                v-model="item.password"
                            />
                            <b-input-group-append style="height: 35px">
                                <b-button
                                    :title="$t('Show/Hide password')"
                                    @click="showPassword"
                                    class="px-2"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="primary"
                                >
                                    <i
                                        class="fas fa-fw fa-eye"
                                        v-if="passwordInput === 'password'"
                                    />
                                    <i class="fas fa-fw fa-eye-slash" v-else />
                                </b-button>
                                <b-button
                                    :title="$t('Generate new password')"
                                    @click="$emit('generate')"
                                    class="px-2"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="secondary"
                                >
                                    <i class="fas fa-fw fa-sync" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </div>
                <form-calendar
                    v-model="item.validade"
                    label="Validade do Cadastro"
                />
                <form-select
                    @change="$emit('verificar')"
                    v-model="item.status"
                    label="Status"
                    :itens="status"
                    :ajuda="
                        $t(
                            'When the user is deactivated, the registry is created in the system, so the email is reserved, but can not login until it is activated again'
                        )
                    "
                    :loading="loading"
                />
            </div>
            <div class="float-right mt-3 text-right">
                <button
                    class="btn btn-success"
                    data-style="zoom-in"
                    type="submit"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
                <br/>
                <a 
                    class="router-link-exact-active active px-3" 
                    @click="$bvModal.show('historico-status-tecnico')"
                >
                    <i class="fas fa-history"></i>
                    Histórico de Status
                </a> 
            </div>
        </form>
        <HistoricoStatus
            :id="item.id"
            :status="status"
        />
    </b-card>
</template>
<script>
import HistoricoStatus from '../HistoricoStatus.vue';
export default {
    components: { HistoricoStatus },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        status: {
            type: [Array ,Object],
            default: () => [],
        },
        passwordInput: {
            type: String,
            default: null,
        },
        loading:{
            type: Boolean,
            default: false
        },
        status_item:{
            type: Array,
            default: []
        }
    },
    data() {
        return {};
    },
    methods:{
        showPassword() {
            if (this.passwordInput === "password") {
                this.passwordInput = "text";
            } else {
                this.passwordInput = "password";
            }
        },
    }
};
</script>
